import { PropsWithChildren, useEffect, useRef, useState } from "react";
import { useElementSize } from "usehooks-ts";

import { className } from "utils/strings";
import AdUnit, { AdUnitTypeEnum } from "components/ads/AdUnit";

import "./WithSideAds.scss";
import { AdUnitsKeys } from "./config/units";

const ADS_WIDTH = 384; // 2 × (160 + 16 + 16)

type WithSideAdsProps = PropsWithChildren<{
  leftAds?: AdUnitsKeys[];
  rightAds?: AdUnitsKeys[];
}>;

export const WithSideAds = (props: WithSideAdsProps) => {
  const { children, leftAds, rightAds } = props;

  const [showAds, setShowAds] = useState<boolean>(true);
  const [ref, { width }] = useElementSize();

  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (width === 0) {
      return;
    }

    const contentWidth = contentRef.current?.clientWidth ?? 0;

    const maxWidth = contentWidth + ADS_WIDTH;
    setShowAds(width >= maxWidth);
  }, [width]);

  return (
    <div className={className({
      "skyWrapper": true,
    })} ref={ref}>
      {showAds && leftAds && <div className="left side">
        {
          leftAds.map(name => <AdUnit key={name} name={name} type={AdUnitTypeEnum.DESKTOP}/>)
        }
      </div>}

      <div className="middle" ref={contentRef}>
        {children}
      </div>

      {showAds && rightAds && <div className="right side">
        {
          rightAds.map(name => <AdUnit key={name} name={name} type={AdUnitTypeEnum.DESKTOP}/>)
        }
      </div>}
    </div>
  );
};
